const AppQuestionTypeEnum = Object.freeze({
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    STRING: 'STRING',
    WYSIWYG: 'WYSIWYG',
    TEXTAREA: 'TEXTAREA',
    SECTION: 'SECTION'
});

export default AppQuestionTypeEnum;
